import { createTheme } from '@mui/material';
import colors from './colors';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.blue, 
    },
    secondary: {
      main: colors.darkBlue,
    },
    error: {
      main: colors.red,
    },
    warning: {
      main: colors.orange,
    },
    info: {
      main: colors.pink,
    },
    success: {
      main: colors.green,
    },
    background: {
      default: colors.white,
    },
    text: {
      primary: colors.darkBlue,
    },
  },
});

const setCSSVariables = () => {
    const root = document.documentElement;

    root.style.setProperty('--white', colors.white);

    root.style.setProperty('--blue', colors.blue);
    root.style.setProperty('--dark-sky-blue', colors.darkSkyblue);
    root.style.setProperty('--light-sky-blue', colors.lightSkyblue);
    root.style.setProperty('--dark-blue', colors.darkBlue);
    root.style.setProperty('--light-blue', colors.lightBlue);

    root.style.setProperty('--dark-grey', colors.darkGrey);
    root.style.setProperty('--grey', colors.grey);

    root.style.setProperty('--yellow', colors.yellow);
    root.style.setProperty('--red', colors.red);
    root.style.setProperty('--orange', colors.orange);
    root.style.setProperty('--gold', colors.gold);
    root.style.setProperty('--pink', colors.pink);
    root.style.setProperty('--green', colors.green);
};

export { theme, setCSSVariables };